@if (approvalPending) {
  <div class="alert alert-warning m-2" role="alert">
    Your NuReferral Program Protocols have been updated and require approval.
    @if (showLink) {
      <a routerLink="/ce-portal/referral-program-protocol">Please review and approve your current protocol here.</a>
    } @else {
      Please review and press Approve below.
    }
  </div>
}
